// Simplified from LC2 (src/App.js) — drops MUI X license init and Intercom for now
// (neither is needed by the auth flow); the session-authorization bootstrap on mount is
// kept unchanged.
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {getCookie} from './commons/utils/cookies';
import {setAuthorization} from './app/store/reducers/session';

import AppRoutes from './routes/AppRoutes';
import ThemeCustomization from './themes/ThemeCustomization';

const App = () => {
    const dispatch = useDispatch();
    const sessionToken = getCookie('session_token');

    useEffect(() => {
        dispatch(setAuthorization());
        // eslint-disable-next-line
    }, [sessionToken]);

    return (
        <ThemeCustomization>
            <AppRoutes />
        </ThemeCustomization>
    );
};

export default App;
